(function () {
  'use strict';

  var root = document.querySelector('[data-nx-hero]');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------------------
     Scroll reveal (fade + rise) via IntersectionObserver
     -------------------------------------------------------------------- */
  var revealEls = root.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* --------------------------------------------------------------------
     Nav: solid background after scrolling + mobile burger toggle
     -------------------------------------------------------------------- */
  var nav = root.querySelector('[data-nx-nav]');
  var burger = root.querySelector('[data-nx-burger]');

  function onScrollNav() {
    if (!nav) return;
    if (window.scrollY > 12) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  }
  onScrollNav();
  window.addEventListener('scroll', onScrollNav, { passive: true });

  if (burger && nav) {
    burger.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
    nav.querySelectorAll('.nx-nav__link').forEach(function (link) {
      link.addEventListener('click', function () { nav.classList.remove('is-open'); });
    });
  }

  /* --------------------------------------------------------------------
     Scroll-linked parallax + 3D tilt on the fox visual
     -------------------------------------------------------------------- */
  var visualWrap = root.querySelector('[data-nx-visual]');
  var tiltEl = root.querySelector('[data-nx-tilt]');
  var parallaxEls = root.querySelectorAll('[data-nx-parallax]');

  var pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var mouseX = 0, mouseY = 0, targetRotX = 0, targetRotY = 0, currentRotX = 0, currentRotY = 0;
  var scrollRotY = 0;

  function updateScrollEffects() {
    if (reduceMotion) return;

    // Parallax background grid
    var rect = root.getBoundingClientRect();
    var progress = 1 - Math.min(Math.max((rect.top + rect.height * 0.3) / window.innerHeight, 0), 1);

    parallaxEls.forEach(function (el) {
      var speed = parseFloat(el.getAttribute('data-nx-parallax')) || 0.15;
      el.style.transform = 'translateY(' + (progress * -80 * speed * 5) + 'px)';
    });

    // Rotate the visual slightly based on how far the hero has scrolled past
    if (visualWrap) {
      var vRect = visualWrap.getBoundingClientRect();
      var vProgress = Math.min(Math.max((window.innerHeight - vRect.top) / (window.innerHeight + vRect.height), 0), 1);
      scrollRotY = (vProgress - 0.5) * 10; // range roughly -5deg .. 5deg
    }
  }

  function animateTilt() {
    if (!reduceMotion && tiltEl) {
      currentRotX += (targetRotX - currentRotX) * 0.08;
      currentRotY += (targetRotY + scrollRotY - currentRotY) * 0.08;
      tiltEl.style.transform = 'rotateX(' + currentRotX + 'deg) rotateY(' + currentRotY + 'deg)';
    }
    requestAnimationFrame(animateTilt);
  }

  if (pointerFine && tiltEl && !reduceMotion) {
    root.addEventListener('mousemove', function (e) {
      var rect = root.getBoundingClientRect();
      mouseX = (e.clientX - rect.left) / rect.width - 0.5;
      mouseY = (e.clientY - rect.top) / rect.height - 0.5;
      targetRotY = mouseX * 10;
      targetRotX = mouseY * -8;
    });
    root.addEventListener('mouseleave', function () {
      targetRotX = 0;
      targetRotY = 0;
    });
  }

  if (!reduceMotion) {
    window.addEventListener('scroll', updateScrollEffects, { passive: true });
    window.addEventListener('resize', updateScrollEffects);
    updateScrollEffects();
    requestAnimationFrame(animateTilt);
  }
})();
